import React, { Component } from "react";
import { CallAPI, HandleTextChange, parseIntFromStr, GetCookieFunction } from '../../utils/util';
import Alert from 'react-bootstrap/Alert';
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import VoiceInput from '../../utils/VoiceInput';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params, searchParams }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class FamilySocialHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "rows": {},
            "patientID": parseIntFromStr(this.props.router.params.patientId),
            "staffID": GetCookieFunction("User").id,
            "modalVariant": "",
            "modalMessage": ""
        };

        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        // Is this page being access as a funnel mode?
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";
    };

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientID}/medicalHistory`, 'GET', (res) => {
            var orders = undefined;
            if (!res){
                console.log("No results found");    // Should not happen.
                orders = {};
            } else {
                orders = res;
            }
            this.setState({"rows": orders})
        }, (message) => {
            this.setState({
                "modalVariant": "danger",
                "modalMessage": "Error loading patient data: " + message.message
            })
        });
    }

    // TODO: Put in correct api name
    handleSubmit(event) {
        event.preventDefault();

        CallAPI(
            {
                "rows": this.state.rows, 
                "patientID": this.state.patientID,
                "staffID": this.state.staffID
            }, 
            `patients/${this.state.patientID}/medicalHistory`, 'PUT', (res) => {
                // TODO: Change forwarding for funnel
                if (this.funnel){
                    this.props.router.navigate("/patients/"+this.state.patientID+"/reviewSystems"+this.funnel);
                } else {
                    this.setState({
                        "modalVariant": "success",
                        "modalMessage": "Patient history has been saved."
                    });
                }
            },
            (message) => {
                this.setState({
                    "modalVariant": "danger",
                    "modalMessage": "Patient history could not be saved."
                })
            }
        );
    };

    render = () => {
        return (
            <div>
                <PatientNav patientId={this.state.patientID} />
                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.state.patientID} currentStep={3} />}
                    <div className="ci-header">
                        <h2>Family &amp; Social History</h2>
                        <p>Document the patient's family and social background</p>
                    </div>
                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                    )}
                    <form onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="ci-card">
                            <div className="ci-field">
                                <label htmlFor="SocialHistory">Social History</label>
                                <div className="ci-field-with-voice">
                                    <textarea id="SocialHistory" name="SocialHistory" maxLength="500" rows={4}
                                        placeholder="Describe the patient's social history..."
                                        value={this.state.rows.SocialHistory || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                    <VoiceInput language="en" onTranscript={(text) => {
                                        this.setState(prev => ({
                                            rows: { ...prev.rows, SocialHistory: (prev.rows.SocialHistory || "") + (prev.rows.SocialHistory ? " " : "") + text }
                                        }));
                                    }} />
                                </div>
                            </div>
                        </div>
                        <div className="ci-card">
                            <div className="ci-field">
                                <label htmlFor="FamilyHistory">Family Illness History</label>
                                <div className="ci-field-with-voice">
                                    <textarea id="FamilyHistory" name="FamilyHistory" maxLength="500" rows={4}
                                        placeholder="Describe relevant family illness history..."
                                        value={this.state.rows.FamilyHistory || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                    <VoiceInput language="en" onTranscript={(text) => {
                                        this.setState(prev => ({
                                            rows: { ...prev.rows, FamilyHistory: (prev.rows.FamilyHistory || "") + (prev.rows.FamilyHistory ? " " : "") + text }
                                        }));
                                    }} />
                                </div>
                            </div>
                        </div>
                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">Save Changes</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    };
}

export default withRouter(FamilySocialHistory)